var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewcontact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "94.8 124.6 235.7 168.3",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 1468,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "__id338_sghrzgu71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.6,181.787c0,0,101.775-14.25,120.303,9.915c15.201,19.83,16.523,57.903,1.32,69.141 c-15.203,11.237-38.338,6.874-38.338,6.874s17.188,19.83,14.543,22.474s-25.67-9.915-34.648-17.186s-51.049-0.437-63.18-4.627 c-21.813-7.535-35.693-38.999-30.406-60.151C168.482,187.075,185.705,182.36,193.6,181.787z",
    style: {
      fill: "rgb(187, 187, 189)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id339_sghrzgu71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.602,138.822c0,0-101.777-14.25-120.303,9.915c-15.203,19.83-16.525,57.903-1.322,69.14 s38.338,6.875,38.338,6.875s-17.186,19.83-14.541,22.474c2.643,2.645,25.67-9.915,34.646-17.186 c8.979-7.271,51.049-0.437,63.182-4.627c21.813-7.535,35.693-38.999,30.404-60.15C256.719,144.11,239.496,139.396,231.602,138.822 z",
    style: {
      fill: "rgb(9, 84, 126)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id340_sghrzgu71",
    style: {
      fill: "rgb(250, 250, 250)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.391,177.951c0,0-8.576,3.835-4.594,6.665c3.98,2.83,10.414,1.911,10.107-1.765 S162.834,176.625,160.391,177.951z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238,178.391c0,0-6.74,4.975,0,7.119c6.738,2.144,7.658-1.604,7.045-3.559 S181.832,176.174,177.238,178.391z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.922,177.72c0,0-4.594,1.787-3.982,5.156c0.613,3.369,4.594,4.407,6.738,3.275 c2.146-1.132,4.902-4.194,3.676-6.032C201.129,178.282,198.025,176.496,195.922,177.72z",
    style: {
      fill: "inherit"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcontact);
export default __webpack_public_path__ + "static/media/newcontact.d634bfb4caea5d68e402c4b3db6d2248.svg";
export { ForwardRef as ReactComponent };